import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
export default forwardRef((props, ref) => jsx("svg", {
    viewBox: "0 0 354 216",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref,
    ...props,
    dangerouslySetInnerHTML: { __html: '<path d="M40 8a8 8 0 0 1 8-8h258a8 8 0 0 1 8 8v48a8 8 0 0 1-8 8H48a8 8 0 0 1-8-8z" fill="#F6F6F6"/> <path fill="#E8E8E9" d="M56 16h242v12H56zm0 20h184v12H56z"/> <path d="M40 84a8 8 0 0 1 8-8h258a8 8 0 0 1 8 8v48a8 8 0 0 1-8 8H48a8 8 0 0 1-8-8z" fill="#F6F6F6"/> <path fill="#E8E8E9" d="M56 92h242v12H56zm0 20h184v12H56z"/> <path d="M40 160a8 8 0 0 1 8-8h258a8 8 0 0 1 8 8v48a8 8 0 0 1-8 8H48a8 8 0 0 1-8-8z" fill="#F6F6F6"/> <path fill="#E8E8E9" d="M56 168h242v12H56zm0 20h184v12H56z"/>' }
  })
);